import React from 'react';
import { Motion, spring } from 'react-motion';
import SVG from 'react-inlinesvg';
import { connect } from 'react-redux';

import './index.css';
import { toggleFormsModal } from '../../actions';
import Button from '../../components/button';
import groupPhoto from '../../images/about/photo.jpg';
import LeoTrado from '../../images/about/LEO_TRADO.svg';

const progressBars = [
  {
    label: localStorage.getItem('lang') == 'ru'? 'UX | UI дизайн':'UX | UI design',
    percentage: 100
  },
  {
    label: localStorage.getItem('lang') == 'ru'? 'Брэндинг':'Branding' ,
    percentage: 95
  },
  {
    label: localStorage.getItem('lang') == 'ru'? 'Программирование':'Programming',
    percentage: 100
  },
  {
    label: "SEO",
    percentage: 85
  }
]

const About = (props) => (
  <div className="about page">
    <div className="about__header">
      <h1>{localStorage.getItem('lang') == 'ru'? 'О нас':'About us'}</h1>
      <span className="subtitle">{localStorage.getItem('lang') == 'ru'? 'Делаем проекты с львиным характером':'Creative project is Leo'}</span>
    </div>
    <div className="about__body">
      <div className="about__info__wrapper">
        <div className="about__info__col">
          <h2 className="about__info__title">Leo trado</h2>
          <p className="about__info__description">
            {localStorage.getItem('lang') == 'ru'? 'На протяжении 6 лет мы реализовываем сложные интересные проекты. Для каждого проекта мы используем комплексный подход и находим лучшие концепции для решения бизнес-задач.':
            'For 6 years we have been implementing complex and interesting projects. For each project we use an integrated approach and ﬁnd the best concepts to solve business problems.'}
          </p>
          <p className="about__info__description">
          {localStorage.getItem('lang') == 'ru'? 'Главная концепция компании Leo Trado - «простота». Именно через эту призму проходят все проекты перед презентацией заказчику. Особое внимание уделяем чистоте интерфейса и потребностям пользователей, создавая корпоративные сайты, интернет-магазины и помогая реализовать потенциал стартапам различной тематики.':
          'The main concept of Leo Trado is «simplicity». Through this prism all projects pass before presentation to the customer. We pay special attention to the cleanliness of the interface and the needs of the users, creating corporate sites, online shops and helping to realize the potential of start-ups of various topics.'}
          </p>
          <Button handler={() => props.toggleFormsModal(true, 'join')}>{localStorage.getItem('lang') == 'ru'? 'Хочу в команду':'Join us'}</Button>
        </div>
        <div className="about__info__col">
          {progressBars.map(item => (
            <Motion
              key={item.label}
              defaultStyle={{ width: 0 }}
              style={{ width: spring(item.percentage, { stiffness: 145, damping: 36 }) }}>
              {interpolatedStyles => (
                <div className="about__stats">
                  <div className="about__stats__row">
                    <span className="about__stats__label">{item.label}</span>
                    <span className="about__stats__label">{Math.round(interpolatedStyles.width)}%</span>
                  </div>
                  <div className="about__stats__progress">
                    <span
                      className="about__stats__progress__bar"
                      style={{
                        width: `${interpolatedStyles.width}%`
                      }}></span>
                  </div>
                </div>
              )}
            </Motion>
          ))}
        </div>
      </div>
    </div>
    <div className="about__facts">
      <div className="about__facts__wrapper">
        <div className="about__fact">
          <span className="about__fact__amount">&nbsp;&nbsp;108+</span>
          <span className="about__fact__line"></span>
          <span className="about__fact__label">{localStorage.getItem('lang') == 'ru'? 'Завершенных проекта':'completed projects'}</span>
        </div>
        <div className="about__fact">
          <span className="about__fact__amount">6</span>
          <span className="about__fact__line"></span>
          <span className="about__fact__label">{localStorage.getItem('lang') == 'ru'? 'Лет работы':'years of work'}</span>
        </div>
        <div className="about__fact">
          <span className="about__fact__amount">22</span>
          <span className="about__fact__line"></span>
          <span className="about__fact__label">{localStorage.getItem('lang') == 'ru'? 'Профессионала':'professionals'}</span>
        </div>
        <div className="about__fact">
          <span className="about__fact__amount">&nbsp;&nbsp;92+</span>
          <span className="about__fact__line"></span>
          <span className="about__fact__label">{localStorage.getItem('lang') == 'ru'? 'Клиента':'Clients'}</span>
        </div>
        <div className="about__fact">
          <span className="about__fact__amount">3047</span>
          <span className="about__fact__line"></span>
          <span className="about__fact__label">{localStorage.getItem('lang') == 'ru'? 'Выпитых кружек кофе':'Drank cups of coﬀee'}</span>
        </div>
      </div>
    </div>
    <div className="about__photo">
      <img src={groupPhoto} alt="Команда Leo Trado" />
      <div className="about__photo__title-wrapper">
        <SVG src={LeoTrado} className="about__photo__title" />
      </div>
    </div>
  </div>
)

const mapDispatchToProps = (dispatch) => {
  return {
    toggleFormsModal: (flag, tab) => dispatch(toggleFormsModal(flag, tab))
  }
}

export default connect(null, mapDispatchToProps)(About)



// WEBPACK FOOTER //
// ./src/pages/about/index.jsx